import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import styles from "./Offer.module.css";

/* Figma "Camada_1" — vetor 14,28x14,28 #B800FF */
function Diamond() {
  return (
    <svg aria-hidden="true" className={styles.diamond} viewBox="0 0 15 15">
      <path d="M14.4958 6.70167C11.6071 5.71427 9.34872 3.44537 8.36132 0.567226C8.09872-0.189075 7.02729-0.189075 6.76469 0.567226C5.7773 3.45588 3.50839 5.71427 0.630248 6.70167C-0.126053 6.96427-0.126053 8.0357 0.630248 8.2983C3.5189 9.2857 5.7773 11.5546 6.76469 14.4327C7.02729 15.189 8.09872 15.189 8.36132 14.4327C9.34872 11.5441 11.6176 9.2857 14.4958 8.2983C15.2521 8.0357 15.2521 6.96427 14.4958 6.70167Z" />
    </svg>
  );
}

/* Figma pinta o trecho final do titulo com outro fill (run override) */
function Accent({ text, accent, className }: { text: string; accent: string; className: string }) {
  const index = text.indexOf(accent);
  if (index < 0) return <>{text}</>;
  return (
    <>
      {text.slice(0, index)}
      <span className={className}>{accent}</span>
      {text.slice(index + accent.length)}
    </>
  );
}

export function Offer() {
  const { offer } = useMaestriaContent();
  const [metodo, plano, agente] = offer.items;

  return (
    <section id="oferta" className={`maestria-section ${styles.section}`} aria-labelledby="offer-title">
      <div className={`maestria-container ${styles.inner}`}>
        <h2 id="offer-title" className={styles.header}>
          <span className={styles.eyebrow}>{offer.eyebrow}</span>
          <span className={styles.wordmark}>{offer.title}</span>
        </h2>

        <ul className={styles.list}>
          <li className={`${styles.row} ${styles.rowMetodo}`}>
            <div className={styles.cardLight}>
              <h3 className={styles.cardTitle}>
                <Accent text={metodo.title} accent={metodo.titleAccent} className={styles.accent} />
              </h3>
              <p className={styles.cardText}>{metodo.description}</p>
            </div>

            <div className={styles.collage} aria-hidden="true">
              {offer.collage.map((src, index) => (
                <img
                  key={src}
                  className={`${styles.photo} ${[styles.photoA, styles.photoB, styles.photoC][index]}`}
                  src={src}
                  alt=""
                  width={231}
                  height={231}
                  loading="lazy"
                />
              ))}
            </div>

            <p className={`${styles.note} ${styles.noteMetodo}`}>{metodo.note}</p>
          </li>

          <li className={`${styles.row} ${styles.rowPlano}`}>
            <div className={styles.mediaStack}>
              <img
                className={styles.mediaPlano}
                src={plano.image}
                alt={plano.imageAlt}
                width={400}
                height={534}
                loading="lazy"
              />
              <p className={styles.caption}>{plano.caption}</p>
            </div>
            <div className={styles.cardCream}>
              <h3 className={styles.cardTitle}>
                <Accent text={plano.title} accent={plano.titleAccent} className={styles.accent} />
              </h3>
              <p className={styles.cardText}>{plano.description}</p>
            </div>

            <p className={`${styles.note} ${styles.notePlano}`}>{plano.note}</p>
          </li>

          <li className={`${styles.row} ${styles.rowAgente}`}>
            <div className={styles.cardDark}>
              <div className={styles.bonus} aria-hidden="true">
                <span className={styles.bonusTrack}>
                  {[0, 1, 2, 3, 4].map((index) => (
                    <span key={index} className={styles.bonusItem}>
                      <span className={styles.bonusLabel}>{offer.bonusLabel}</span>
                      <Diamond />
                    </span>
                  ))}
                </span>
              </div>
              <h3 className={`${styles.cardTitle} ${styles.cardTitleDark}`}>
                <Accent
                  text={agente.title}
                  accent={agente.titleAccent}
                  className={styles.accentGradient}
                />
              </h3>
              <p className={`${styles.cardText} ${styles.cardTextDark}`}>{agente.description}</p>
            </div>

            <div className={styles.mediaStack}>
              <img
                className={styles.mediaAgente}
                src={agente.image}
                alt={agente.imageAlt}
                width={600}
                height={449}
                loading="lazy"
              />
              <p className={styles.caption}>{agente.caption}</p>
            </div>

            <p className={`${styles.note} ${styles.noteAgente}`}>{agente.note}</p>
          </li>
        </ul>
      </div>
    </section>
  );
}
